import type { FunctionComponent } from 'react';
import React from 'react';
import { Link } from 'react-router-dom';

import { cn } from 'helpers/classnames';

import css from 'styles/components/account/returns/returnLegalVerbiage.scss';

interface ReturnLegalVerbiageProps {
  className?: string;
  returnPolicyUrl: string;
}

const ReturnLegalVerbiage: FunctionComponent<ReturnLegalVerbiageProps> = ({ className, returnPolicyUrl = '/shipping-and-returns' }) => (
  <div className={cn(css.container, 'zappos:body-xs-subtle', className)}>
    *The above refund amount is an estimation only. The actual refund amount will be emailed to you once we process the refund. For additional terms,
    see our shipping and returns policy{' '}
    <Link className={cn(css.contactUs, 'zappos:body-xs')} to={returnPolicyUrl}>
      Shipping and Returns
    </Link>
  </div>
);

ReturnLegalVerbiage.defaultProps = {
  className: ''
};

export default ReturnLegalVerbiage;
